var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    rx: 66,
    fill: "#BA1A1A",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 116,
    height: 116,
    rx: 58,
    fill: "#BA1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 51.9533C79.23 51.1833 71.4133 50.7866 63.62 50.7866C59 50.7866 54.38 51.02 49.76 51.4866L45 51.9533",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.834 49.5965L58.3473 46.5398C58.7207 44.3232 59.0007 42.6665 62.944 42.6665H69.0573C73.0007 42.6665 73.304 44.4165 73.654 46.5632L74.1673 49.5965",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9842 59.3271L80.4676 82.8238C80.2109 86.4871 80.0009 89.3338 73.4909 89.3338H58.5109C52.0009 89.3338 51.7909 86.4871 51.5342 82.8238L50.0176 59.3271",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1035 76.5H69.8735",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.166 67.1665H71.8327",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/redTrash.7ee8f366f44a01578eaf521b160551ec.svg";
export { ForwardRef as ReactComponent };